// Admin → BC Registrations tab.
//
// Basketball Connect status and every competition this year, with the BOMS
// coaching programs and Swish IQ sessions created or linked from each line
// (see BCRegistrationsPanel). Sign-in details live under Admin → BC
// Integration.

import React, { useEffect, useState } from 'react';
import { usePermissions } from '../context/PermissionsContext';
import BCRegistrationsPanel from './BCRegistrationsPanel';

const API_BASE = 'https://referee-roster-api-v2-hqghffesdfegd2dq.australiaeast-01.azurewebsites.net/api';

export default function AdminCompetitionMapping() {
  const { canEdit } = usePermissions();
  const canEditRegistrations = canEdit('admin', 'competition-mapping');
  const [bcSettings, setBcSettings] = useState(null);

  // Without saved sign-in details nothing on this page can load, so point
  // the user at BC Integration instead.
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(`${API_BASE}/integrations/bc/settings`, { credentials: 'include' });
        if (!r.ok) return;
        const s = await r.json();
        if (!cancelled) setBcSettings(s);
      } catch { /* ignore */ }
    })();
    return () => { cancelled = true; };
  }, []);

  if (bcSettings && !bcSettings.hasToken) {
    return (
      <div className="admin-section">
        <h2 style={{ marginTop: 0 }}>BC Registrations</h2>
        <div style={{ background: '#fff8e1', border: '1px solid #ffe082', borderRadius: 8, padding: '1.25rem 1.5rem' }}>
          <strong>Basketball Connect not configured.</strong>
          <p style={{ margin: '0.5rem 0 0', fontSize: '0.9rem', color: '#666' }}>
            Save the Basketball Connect sign-in details under <strong>Admin → BC Integration</strong> first. This page
            then loads every competition and registration.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-section">
      <h2 style={{ marginTop: 0 }}>BC Registrations</h2>
      <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '1.25rem' }}>
        Every Basketball Connect registration comes into SwishIQ automatically at 5am, 9am, 12pm and 3pm, with one profile
        per player. From each competition you can create or link a coaching program or SwishIQ Trials session; registered
        players are added to it on every sync.
      </p>
      <BCRegistrationsPanel canEdit={canEditRegistrations} />
    </div>
  );
}
